export const mappedLocations = [
    { invalid: 'IKA', domestic: true, valid: 'THR' },
];
